import i18next from "i18next";

export const validateLeagueName = (e: HTMLInputElement | HTMLTextAreaElement) => {
	const value = e.value;
	let error = "";
	const MIN_LENGTH = 3;
	const MAX_LENGTH = 40;
	if (!value) {
		error = i18next.t("create_league.form.no_value");
	} else if (value.length < MIN_LENGTH) {
		error = i18next.t("create_league.form.short_value");
	} else if (value.length > MAX_LENGTH) {
		error = i18next.t("create_league.form.long_value");
	} else if (!RegExp(/^[A-Za-z0-9][A-Za-z0-9\s]+[A-Za-z0-9]$/).exec(value)) {
		error = i18next.t("create_league.form.invalid_format");
	}

	if (error.length) {
		return error;
	}

	return null;
};
